import React from "react";
import AgregarPlantillasRequisitoExpediente from "./AgregarPlantillasRequisitoExpediente";

export default function AgregarRequisitoExpediente({
  setIsVisibleModal,
  setReload,
  reload,
  id_expediente,
  row,
  idMov,
}) {
  return (
    <>
      <AgregarPlantillasRequisitoExpediente
        setIsVisibleModal={setIsVisibleModal}
        setReload={setReload}
        reload={reload}
        id_expediente={id_expediente}
        requisito={row}
        idMov={idMov}
      />
    </>
  );
}
